import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Styles from './Styles/StoreNotFound.module.css'
import { useNavigate } from 'react-router-dom';

export default function FreeLimitExceeded() {
    const navigate = useNavigate()

    return (
        <div className={Styles.container}>

            <Stack className={Styles.content} justifyContent='space-evenly' alignItems='center'>
                <Typography variant='h4'>
                    Superaste el limite de productos permitidos en tu plan gratuito
                </Typography>
                <Typography variant='h6'>
                    Es probable que tu suscripcion se haya cancelado o tu pago no se haya realizado correctamente. Si crees que esto es un error por favor contactanos
                </Typography>
                <Button variant='outlined' onClick={() => navigate('/')}>
                    Ir a Tookeat
                </Button>
            </Stack>

        </div>
    )
}